import { render } from "./ScreenShare.vue?vue&type=template&id=90961f4e&scoped=true&lang=pug"
import script from "./ScreenShare.vue?vue&type=script&lang=js"
export * from "./ScreenShare.vue?vue&type=script&lang=js"

import "./ScreenShare.vue?vue&type=style&index=0&id=90961f4e&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-90961f4e"]])

export default __exports__